import {putWithAuth} from '@/api'
import {UpdateUserGuiderRequest} from '@/stores/user-guide/models/UpdateUserGuiderRequest'

export const updateUserGuideReadStatus = (request: UpdateUserGuiderRequest) => {
    return putWithAuth<any>('/oppapi/profile', request)
}
